import BaseModel from './BaseModel';
import Payment from './Payment';
import moment from 'moment';

/** Class representing an invoice. */
class Invoice extends BaseModel {
    constructor(properties) {
        super(properties);

        this.created_at = moment(this.created_at);
        this.updated_at = moment(this.updated_at);

        if ('payments' in this)
            this.payments = (this.payments || []).map(payment => new Payment(payment));

        this.amount = Number(this.amount);
        this.paid   = Number(this.paid);
        this.due    = Number(this.due);
    }

    static format(amount) {
        return `${amount?.toFixed(2)} €`;
    }

    formatAmount() {
        return `${this.amount.toFixed(2)} €`;
    }

    formatDue() {
        return `${this.due.toFixed(2)} €`;
    }
}

export default Invoice;
